import React, { useState } from "react";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { mainurl,perpsurl } from "../config/env";


export default function Sidebaraccordion() {
  const [openIndex, setOpenIndex] = useState(null);

  const items = [
    { title: "Trade", 
      sub:[
        {title:"Swap", link:`${mainurl}/swap`},
        {title:"Buy Crypto", link:`${mainurl}/buycrypto`} 
      ]
     },
    {title:"Perps", link:`${perpsurl}`},
    { title: "Earn", 
      sub:[
        {title:"Staking",  link:`${mainurl}/staking`},
        {title:"Liquidity Pools", link:`${mainurl}/liquiditypools`} 
      ]
     },
     {title:"Launchpad", link:"/launchpadlist" },
     { title: "More", 
      sub:[
        {title:"Voting", link:`${mainurl}/voting`},
        {title:"Governance", link:`${mainurl}/governance`},
        {title:"Docs", link:"#"}  
      ]
     },
   ];



  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="overflow-hidden accordion_all">
      {items.map((item, index) => (
         <div key={index} className="mb-3">
       {item.link && !item.sub && (
      <a 
        href={item.link} 
        className="mobilelink pb-1" 
        rel="noopener noreferrer"
      >
        {item.title}
      </a>
    )}

        {item.sub && (
      <div className="fullacc">
        <button
          onClick={() => toggleItem(index)}
          className="accordion_btn"
        >
          {item.title}
          <span>
            {openIndex === index 
              ? <RiArrowDropUpLine fontSize={28}/> 
              : <RiArrowDropDownLine fontSize={28}/>}
          </span>
        </button>

        {openIndex === index && (
          <div className="pt-1">
            <ul className="pl-0">
              {item.sub.map((subItem, subIndex) => (
                <li key={subIndex}>
                  <a 
                    href={subItem.link} 
                    className="mobilelink" 
                    rel="noopener noreferrer"
                  >
                    {subItem.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )}
          </div>

      ))}
    </div>
  );
}
